
import React from 'react';
import { FaCloudUploadAlt } from 'react-icons/fa';

// A reusable component for each piece of profile info
const InfoField = ({ label, value }) => (
  <div>
    <p className="text-sm text-gray-500">{label}</p>
    <p className="font-semibold text-gray-800">{value}</p>
  </div>
);

// A reusable component for password input fields
const PasswordInput = ({ label, id }) => (
  <div>
    <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">
      {label}
    </label>
    <input
      type="password"
      id={id}
      className="w-full p-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
    />
  </div>
);

const SettingsPage = () => {
  return (
    <div className="p-8 bg-gray-50 min-h-screen">
      <div className="max-w-4xl mx-auto space-y-8">
        
        {/* Profile Information Section */}
        <div className="bg-white p-8 rounded-xl shadow-sm">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">Profile Information</h2>
          <div className="flex items-center gap-8">
            <div className="text-center">
              <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center border-2 border-dashed border-gray-300 mb-2">
                <FaCloudUploadAlt className="text-3xl text-gray-400" />
              </div>
              <button className="text-sm font-medium text-indigo-600 hover:text-indigo-800">
                Change Photo
              </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6 flex-1">
              <InfoField label="Full Name" value="" />
              <InfoField label="Email Address" value="" />
              <InfoField label="Job Title" value="" />
              <InfoField label="Department" value="" />
            </div>
          </div>
        </div>

        {/* Security Settings Section */}
        <div className="bg-white p-8 rounded-xl shadow-sm">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">Security Settings</h2>
          <form className="space-y-6 max-w-md">
            <PasswordInput label="Current Password" id="current-password" />
            <PasswordInput label="New Password" id="new-password" />
            <PasswordInput label="Confirm New Password" id="confirm-password" />
            <div className="pt-4">
               <button 
                  type="submit" 
                  className="px-6 py-2 bg-indigo-600 text-white font-semibold rounded-lg shadow-sm hover:bg-indigo-700"
                >
                  Save Changes
                </button>
            </div>
          </form>
        </div>

      </div>
    </div>
  );
};

export default SettingsPage;
